import "./index.css";
import React from "react";
import { render } from "react-dom";
import { App } from "./App";
import { initAnalytics } from "./utils/analytics";
initAnalytics();
render(<App data-id="element-483" data-mp="1wcxurqhwnagd" />, document.getElementById("root"));